import { LocalizationHelper } from '../../shared/helpers/localization/localization.helper';

type Keys =
  | 'invoice'
  | 'invoices_list'
  | 'create_invoice'
  | 'create_invoices'
  | 'multi_create_invoice'
  | 'multi_create_invoice_confirmation'
  | 'multi_create_invoice_confirmation_single_customer'
  | 'no_customers_for_multi_create_invoice'
  | 'creating_multi_invoice'
  | 'number'
  | 'customer_active'
  | 'delivery_note_group'
  | 'invoicing_interval'
  | 'send_letter'
  | 'email_service'
  | 'no_data_for_export'
  | 'no_data_for_sepa_export'
  | 'invoice_date'
  | 'text'
  | 'creating_invoice'
  | 'orders'
  | 'items'
  | 'generating_invoice_pdfs'
  | 'creating_billing_documents'
  | 'compiling_multiple_invoices'
  | 'finalizing_invoice_layouts'
  | 'preparing_financial_documents_download'
  | 'bundling_pdfs'
  | 'creating_invoices'
  | 'processing_multiple_invoices'
  | 'calculating_totals_preparing_pdfs'
  | 'finalizing_invoice_data'
  | 'invoices_on_the_way'
  | 'number_of_created_invoices'
  | 'auto_preview_email'
  | 'customers'
  | 'invoices'
  | 'invoices_range'
  | 'open_invoices_to_date'
  | 'delete_invoice'
  | 'deleting_invoice'
  | 'invoice_successfully_deleted'
  | 'want_to_delete_invoice'
  | 'datetime_of_last_email_message'
  | 'invoice_no'
  // errors messages -->
  | 'error_failed_to_delete_entry'
  | 'error_failed_to_load_deleted_invoices'
  | 'error_failed_to_load_order_positions'
  | 'error_failed_to_load_customer_details'
  | 'error_failed_to_load_invoice_data'
  | 'error_failed_to_load_created_invoice_list'
  | 'error_failed_to_get_order_for_created_invoice'
  | 'error_failed_to_load_report_a4'
  | 'error_failed_to_load_invoice_summary'
  | 'error_failed_to_load_invoice_payment_slip'
  | 'error_failed_to_load_invoice_a4_detailed'
  | 'error_failed_to_load_invoice_journal'
  | 'error_failed_to_load_invoice_article_grouping'
  | 'error_failed_to_load_invoice_customer_grouping'
  | 'error_failed_to_load_invoice_delivery_overview'
  | 'error_failed_to_load_invoice_payment_slip_with_qr'
  | 'error_order_position_not_loaded'
  | 'error_customers_details_not_loaded'
  | 'error_invoice_not_created'
  | 'invoice_not_saved'
  | 'invoice_with_id_not_saved'
  | 'abacus_export'
  | 'datev_export'
  | 'sepa_export'
  | 'settings_error'
  | 'please_complete_the_following_settings_first'
  | 'export_valid_only'
  | 'the_customers_listed_below_are_missing_mandatory_bank_details'
  | 'complete_the_data'
  | 'some_customers_missed_mandatory_bank_details'
  // <-- errors messages
  | 'exported_sepa'
  | 'exported_datev_or_abacus'
  | 'legend_is_deleted'
  | 'email_message'
  | 'invoice_journal'
  | 'action'
  | 'delete_reason'
  | 'manual_selection'
  | 'create_multiple_invoices'
  | 'payment_slip'
  | 'invoice_summary'
  | 'pdf_export'
  | 'invoices_pdf_export'
  | 'invoice_export'
  | 'invoice_summary_export'
  | 'payment_slip_export'
  | 'archive_ready_download_will_start_automatically'
  | 'archive_is_empty'
  | 'following_fields_dont_meet_einvoice_requirements_warning';

const t = LocalizationHelper<Keys>('invoice');

export const invoiceDe = t({
  invoice: 'Rechnung',
  invoices_list: 'Rechnungsliste',
  create_invoice: 'Rechnung erstellen',
  create_invoices: 'Rechnungen erstellen',
  number: 'Nummer',
  sepa_export: 'SEPA-Export',
  creating_invoices: 'Rechnungen werden erstellt – bitte haben Sie einen Moment Geduld...',
  processing_multiple_invoices: 'Mehrere Rechnungen werden verarbeitet...',
  calculating_totals_preparing_pdfs: 'Summen werden berechnet und PDFs vorbereitet...',
  finalizing_invoice_data: 'Rechnungsinhalte werden abschließend aufbereitet...',
  invoices_on_the_way: 'Einen Augenblick – Ihre Rechnungen werden gerade bereitgestellt...',
  generating_invoice_pdfs: 'Rechnungen werden als PDFs vorbereitet...',
  creating_billing_documents: 'Rechnungsunterlagen werden erstellt...',
  compiling_multiple_invoices: 'Mehrere Rechnungen werden gesammelt aufbereitet...',
  finalizing_invoice_layouts: 'Layout der Rechnungen wird abgestimmt...',
  preparing_financial_documents_download: 'Finanzdokumente werden für den Download vorbereitet...',
  bundling_pdfs: 'Fast abgeschlossen – Ihre PDFs werden abgeschlossen...',
  exported_sepa: 'Exportiert (SEPA)',
  exported_datev_or_abacus: 'Exportiert (DATEV/Abacus)',
  settings_error: 'Fehler in den Einstellungen',
  export_valid_only: 'Nur gültige exportieren',
  some_customers_missed_mandatory_bank_details: 'Es fehlen sämtliche Bankdaten beim Kunden',
  the_customers_listed_below_are_missing_mandatory_bank_details:
    'Bei den unten aufgeführten Kunden fehlen verpflichtende Bankdaten, daher werden ihre Rechnungen übersprungen: {{names}}',
  please_complete_the_following_settings_first:
    'Bitte vervollständigen Sie zuerst die folgenden Einstellungen: {{list}}',
  complete_the_data: 'Daten ergänzen',
  invoice_journal: 'Rechnungsjournal',
  customers: 'Kunden',
  invoices: 'Rechnungen',
  customer_active: 'Kunde ist aktiv',
  delivery_note_group: 'Lieferscheingruppe',
  invoicing_interval: 'Abrechnung',
  send_letter: 'Briefversand',
  email_service: 'Email Service',
  no_data_for_export: 'Keine Daten zum Exportieren',
  no_data_for_sepa_export:
    'Keine der ausgewählten Rechnungen kann exportiert werden. Möglicherweise wurde die Zahlung bereits vorgenommen',
  invoice_date: 'Rechnungsdatum',
  text: 'Text',
  creating_invoice: 'Rechnung erstellen...',
  orders: 'Bestellungen',
  items: 'Positionen',
  number_of_created_invoices: 'Anzahl der erstellten Rechnungen',
  auto_preview_email: 'Automatische Vorschau/Email',
  invoice_not_saved: 'Fehler: Rechnung nicht gespeichert!',
  invoice_no: 'Rechnung-Nr.',
  invoices_range: 'Rechnungen Bereich',
  open_invoices_to_date: 'Offene Rechnungen bis Datum',
  delete_invoice: 'Rechnung stornieren',
  deleting_invoice: 'Rechnung stornieren...',
  invoice_successfully_deleted: 'Rechnung erfolgreich gelöscht',
  want_to_delete_invoice: 'Wollen Sie die Rechnung wirklich stornieren?',
  datetime_of_last_email_message: 'Email wurde verschickt am {{date}} um {{time}}',
  legend_is_deleted: 'Stornierte Rechnung',
  email_message:
    'Sehr geehrte Damen und Herren\n \nIn der Beilage erhalten Sie die Rechnung [FakturaNr] zur Zahlung. Wir danken Ihnen für Ihren Auftrag.\n \nMit freundlichen Grüssen',
  action: 'Aktion',
  delete_reason: 'Löschen Grund',
  error_order_position_not_loaded: 'Bestellpositionen wurden nicht hochgeladen!',
  error_customers_details_not_loaded: 'Kundendaten wurden nicht hochgeladen!',
  invoice_with_id_not_saved: 'Fehler: Rechnung {{id}} nicht gespeichert!',
  multi_create_invoice: 'Mehrere Rechnungen erstellen',
  multi_create_invoice_confirmation: 'Möchten Sie {{count}} Kunden automatisch verrechnen?',
  multi_create_invoice_confirmation_single_customer: 'Möchten Sie 1 Kunde automatisch verrechnen?',
  no_customers_for_multi_create_invoice:
    'Es gibt keine berechtigten Kunden, mehrere Rechnungen zu erstellen.',
  creating_multi_invoice: 'Erstellen mehrerer Rechnungen',
  error_invoice_not_created: 'Rechnung wurde nicht erstellt!',
  manual_selection: 'Manuelle Auswahl',
  create_multiple_invoices: 'Mehrere Rechnungen erstellen',
  error_failed_to_delete_entry: 'Eintrag konnte nicht gelöscht werden',
  error_failed_to_load_deleted_invoices: 'Gelöschte Rechnungen konnten nicht geladen werden',
  error_failed_to_load_order_positions: 'Auftragspositionen konnten nicht geladen werden',
  error_failed_to_load_customer_details: 'Kundendaten konnten nicht geladen werden',
  error_failed_to_load_invoice_data: 'Rechnungsdaten konnten nicht geladen werden',
  error_failed_to_load_created_invoice_list:
    'Die erstellte Rechnungsliste konnte nicht geladen werden',
  error_failed_to_get_order_for_created_invoice:
    'Für die erstellte Rechnung konnten keine Bestellungen abgerufen werden',
  error_failed_to_load_report_a4: 'Rechnungsbericht A4 konnte nicht geladen werden',
  error_failed_to_load_invoice_summary: 'Rechnungszusammenfassung konnte nicht geladen werden',
  error_failed_to_load_invoice_payment_slip:
    'Der Zahlungsbeleg der Rechnung konnte nicht geladen werden',
  error_failed_to_load_invoice_a4_detailed:
    'Das Laden der detaillierten A4-Rechnung ist fehlgeschlagen',
  error_failed_to_load_invoice_journal: 'Rechnungsjournal konnte nicht geladen werden',
  error_failed_to_load_invoice_article_grouping:
    'Artikelgruppierungsrechnung A4 konnte nicht geladen werden',
  error_failed_to_load_invoice_customer_grouping:
    'Kundengruppierungsrechnung A4 konnte nicht geladen werden',
  error_failed_to_load_invoice_delivery_overview:
    'Die Rechnungszustellungsübersicht konnte nicht geladen werden',
  error_failed_to_load_invoice_payment_slip_with_qr:
    'Der Zahlungsbeleg mit QR-Code konnte nicht geladen werden',
  payment_slip: 'Einzahlungsschein',
  invoice_summary: 'Zusammenzug zu Rechnung',
  abacus_export: 'Abacus XML-Export',
  datev_export: 'DATEV-Export',
  pdf_export: 'PDF-Export',
  invoices_pdf_export: 'PDF‑Export von Rechnungen',
  invoice_export: 'Rechnungs‑Export',
  invoice_summary_export: 'Zusammenzug zu Rechnungs‑Export',
  payment_slip_export: 'Einzahlungsschein Export',
  archive_ready_download_will_start_automatically:
    'Archiv fertig. Der Download startet automatisch.',
  archive_is_empty: 'Das Archiv ist leer.',
  following_fields_dont_meet_einvoice_requirements_warning:
    'Die folgenden Felder erfüllen nicht die E-Rechnungs-Anforderungen. Bitte korrigieren Sie diese vor der Rechnungserstellung.',
});

export const invoiceFr = t({
  invoice: 'Facture',
  invoices_list: 'Liste des factures',
  create_invoice: 'Créer une facture',
  create_invoices: 'Créer des factures',
  number: 'Numéro',
  creating_invoices: 'Création des factures – veuillez patienter...',
  processing_multiple_invoices: 'Traitement de plusieurs factures...',
  calculating_totals_preparing_pdfs: 'Calcul des totaux et préparation des fichiers PDF...',
  finalizing_invoice_data: 'Finalisation des données de facturation...',
  invoices_on_the_way: 'Un instant – vos factures sont en route !',
  generating_invoice_pdfs: 'Les factures sont préparées au format PDF...',
  creating_billing_documents: 'Les documents de facturation sont en cours de création...',
  compiling_multiple_invoices: 'Plusieurs factures sont regroupées et traitées...',
  finalizing_invoice_layouts: 'La mise en page des factures est en cours d’ajustement...',
  preparing_financial_documents_download:
    'Les documents financiers sont préparés pour le téléchargement...',
  bundling_pdfs: 'Presque terminé – vos fichiers PDF sont en cours de finalisation...',
  exported_sepa: 'Exporté (SEPA)',
  exported_datev_or_abacus: 'Exporté (DATEV/Abacus)',
  some_customers_missed_mandatory_bank_details:
    "Certains clients n'ont pas renseigné les coordonnées bancaires obligatoires",
  sepa_export: 'Export SEPA',
  settings_error: 'Erreur de paramètres',
  export_valid_only: 'Exporter uniquement les valides',
  the_customers_listed_below_are_missing_mandatory_bank_details:
    "Les clients listés ci-dessous n'ont pas renseigné les coordonnées bancaires obligatoires, leurs factures seront donc ignorées : {{names}}",
  please_complete_the_following_settings_first:
    "Veuillez d'abord compléter les paramètres suivants : {{list}}",
  complete_the_data: 'Compléter les données',
  customers: 'Clients',
  invoices: 'Factures',
  invoice_journal: 'Journal des factures',
  customer_active: 'Le client est actif',
  delivery_note_group: 'Groupe de bons de livraison',
  invoicing_interval: 'Intervalle de facturation',
  send_letter: 'Envoyer une lettre',
  email_service: 'Service de messagerie',
  no_data_for_export: 'Aucune donnée à exporter',
  no_data_for_sepa_export:
    'Aucune des factures sélectionnées ne peut être exportée. Le paiement a peut-être déjà été effectué',
  invoice_date: 'Date de la facture',
  text: 'Texte',
  creating_invoice: 'Création de la facture...',
  orders: 'Commandes',
  items: 'Articles',
  auto_preview_email: 'Aperçu/Email automatique',
  invoice_no: 'Facture N°',
  invoice_not_saved: 'Erreur : Facture non enregistrée !',
  invoice_with_id_not_saved: 'Erreur : Facture {{id}} non enregistrée !',
  invoices_range: 'Plage des factures',
  open_invoices_to_date: 'Factures ouvertes à ce jour',
  delete_invoice: 'Supprimer la facture',
  deleting_invoice: 'Suppression de la facture...',
  invoice_successfully_deleted: 'Facture supprimée avec succès',
  want_to_delete_invoice: 'Voulez-vous vraiment supprimer la facture ?',
  datetime_of_last_email_message: "L'email a été envoyé le {{date}} à {{time}}",
  number_of_created_invoices: 'Nombre de factures créées',
  legend_is_deleted: 'Facture supprimée',
  email_message:
    'Madame, Monsieur\n \nVeuillez trouver ci-joint la facture [FakturaNr] à régler. Merci pour votre commande.\n \nCordialement',
  action: 'Action',
  delete_reason: 'Raison de la suppression',
  error_order_position_not_loaded: "Les positions de commande n'ont pas été chargées !",
  error_customers_details_not_loaded: "Les détails des clients n'ont pas été chargés !",
  multi_create_invoice: 'Création multiple de factures',
  multi_create_invoice_confirmation:
    'Voulez-vous automatiquement créer des factures pour {{count}} clients?',
  multi_create_invoice_confirmation_single_customer:
    'Voulez-vous automatiquement créer des factures pour 1 client?',
  no_customers_for_multi_create_invoice:
    'Aucun client éligible pour la création multiple de factures.',
  creating_multi_invoice: 'Création de factures multiples',
  error_invoice_not_created: "La facture n'a pas été créée !",
  manual_selection: 'Sélection manuelle',
  create_multiple_invoices: 'Créer plusieurs factures',
  error_failed_to_delete_entry: "Échec de la suppression de l'entrée",
  error_failed_to_load_deleted_invoices: 'Échec du chargement des factures supprimées',
  error_failed_to_load_order_positions: 'Échec du chargement des positions de commande',
  error_failed_to_load_customer_details: 'Échec du chargement des détails du client',
  error_failed_to_load_invoice_data: 'Échec du chargement des données de la facture',
  error_failed_to_load_created_invoice_list: 'Échec du chargement de la liste des factures créées',
  error_failed_to_get_order_for_created_invoice:
    'Échec de la récupération de la commande pour la facture créée',
  error_failed_to_load_report_a4: 'Échec du chargement du rapport de la facture A4',
  error_failed_to_load_invoice_summary: 'Échec du chargement du récapitulatif de la facture',
  error_failed_to_load_invoice_payment_slip:
    'Échec du chargement du bulletin de paiement de la facture',
  error_failed_to_load_invoice_a4_detailed: 'Échec du chargement de la facture détaillée A4',
  error_failed_to_load_invoice_journal: 'Échec du chargement du journal des factures',
  error_failed_to_load_invoice_article_grouping:
    "Échec du chargement du regroupement d'articles pour la facture A4",
  error_failed_to_load_invoice_customer_grouping:
    'Échec du chargement du regroupement des clients pour la facture A4',
  error_failed_to_load_invoice_delivery_overview:
    "Échec du chargement de l'aperçu des livraisons pour la facture",
  error_failed_to_load_invoice_payment_slip_with_qr:
    'Échec du chargement du bulletin de paiement de la facture avec QR-code',
  payment_slip: 'Bordereau de paiement',
  invoice_summary: 'Résumé de facture',
  abacus_export: 'Abacus XML-Export',
  datev_export: 'Exportation Datev',
  pdf_export: 'Exportation PDF',
  invoices_pdf_export: 'Exportation PDF des factures',
  invoice_export: 'Exportation des factures',
  invoice_summary_export: 'Exportation du résumé des factures',
  payment_slip_export: 'Exportation des bordereaux de paiement',
  archive_ready_download_will_start_automatically:
    'Archive prête. Le téléchargement démarrera automatiquement.',
  archive_is_empty: 'L’archive est vide.',
  following_fields_dont_meet_einvoice_requirements_warning:
    'Les champs suivants ne satisfont pas aux exigences de la facturation électronique. Veuillez les corriger avant de créer la facture.',
});

export const invoiceIt = t({
  invoice: 'Fattura',
  invoices_list: 'Elenco fatture',
  create_invoice: 'Crea fattura',
  create_invoices: 'Crea fatture',
  number: 'Numero',
  exported_sepa: 'Esportato (SEPA)',
  exported_datev_or_abacus: 'Esportato (DATEV/Abacus)',
  sepa_export: 'Esportazione SEPA',
  creating_invoices: 'Creazione delle fatture – attendere prego...',
  processing_multiple_invoices: 'Elaborazione di più fatture...',
  calculating_totals_preparing_pdfs: 'Calcolo dei totali e preparazione dei PDF...',
  finalizing_invoice_data: 'Finalizzazione dei dati della fattura...',
  invoices_on_the_way: 'Un momento – le tue fatture stanno arrivando!',
  generating_invoice_pdfs: 'Le fatture vengono preparate in formato PDF...',
  creating_billing_documents: 'I documenti di fatturazione sono in fase di creazione...',
  compiling_multiple_invoices: 'Più fatture vengono elaborate in modo congiunto...',
  finalizing_invoice_layouts: 'Il layout delle fatture viene concordato...',
  preparing_financial_documents_download:
    'I documenti finanziari sono in preparazione per il download...',
  bundling_pdfs: 'Quasi completato – i tuoi file PDF stanno per essere completati...',
  settings_error: 'Errore nelle impostazioni',
  export_valid_only: 'Esporta solo quelli validi',
  some_customers_missed_mandatory_bank_details:
    'Alcuni clienti non hanno inserito i dati bancari obbligatori',
  the_customers_listed_below_are_missing_mandatory_bank_details:
    'Ai clienti elencati di seguito mancano i dati bancari obbligatori, quindi le loro fatture verranno ignorate: {{names}}',
  please_complete_the_following_settings_first:
    'Si prega di completare prima le seguenti impostazioni: {{list}}',
  complete_the_data: 'Completare i dati',
  customers: 'Clienti',
  invoice_journal: 'Registro delle fatture',
  invoices: 'Fatture',
  customer_active: 'Cliente attivo',
  delivery_note_group: 'Gruppo bolla di consegna',
  invoicing_interval: 'Intervallo di fatturazione',
  send_letter: 'Invia lettera',
  email_service: 'Servizio email',
  no_data_for_export: 'Nessun dato da esportare',
  no_data_for_sepa_export:
    'Nessuna delle fatture selezionate può essere esportata. Il pagamento potrebbe essere già stato effettuato',
  invoice_date: 'Data fattura',
  text: 'Testo',
  creating_invoice: 'Creazione fattura...',
  orders: 'Ordini',
  items: 'Articoli',
  auto_preview_email: 'Anteprima/email automatica',
  invoice_no: 'N. Fattura',
  invoice_not_saved: 'Errore: Fattura non salvata!',
  invoice_with_id_not_saved: 'Errore: Fattura con ID {{id}} non salvata!',
  invoices_range: 'Intervallo fatture',
  open_invoices_to_date: 'Fatture aperte alla data',
  delete_invoice: 'Elimina fattura',
  deleting_invoice: 'Eliminazione fattura...',
  invoice_successfully_deleted: 'Fattura eliminata con successo',
  want_to_delete_invoice: 'Sei sicuro di voler eliminare la fattura?',
  datetime_of_last_email_message: 'Email inviata il {{date}} alle {{time}}',
  number_of_created_invoices: 'Numero di fatture create',
  legend_is_deleted: 'Fattura eliminata',
  email_message:
    'Gentili Signore e Signori\n\nIn allegato troverete la fattura [FakturaNr] da pagare. Grazie per il vostro ordine.\n\nCordiali saluti',
  action: 'Azione',
  delete_reason: "Motivo dell'eliminazione",
  error_order_position_not_loaded: "Posizioni dell'ordine non caricate!",
  error_customers_details_not_loaded: 'Dettagli clienti non caricati!',
  multi_create_invoice: 'Creazione multipla di fatture',
  multi_create_invoice_confirmation: 'Vuoi creare automaticamente fatture per {{count}} clienti?',
  multi_create_invoice_confirmation_single_customer:
    'Vuoi creare automaticamente fatture per 1 client?',
  no_customers_for_multi_create_invoice:
    'Non ci sono clienti idonei per la creazione multipla di fatture.',
  creating_multi_invoice: 'Creazione multipla di fatture in corso',
  error_invoice_not_created: 'Fattura non creata!',
  manual_selection: 'Selezione manuale',
  create_multiple_invoices: 'Crea fatture multiple',
  error_failed_to_delete_entry: 'Eliminazione voce non riuscita',
  error_failed_to_load_deleted_invoices: 'Impossibile caricare le fatture eliminate',
  error_failed_to_load_order_positions: "Impossibile caricare le posizioni dell'ordine",
  error_failed_to_load_customer_details: 'Impossibile caricare i dettagli del cliente',
  error_failed_to_load_invoice_data: 'Impossibile caricare i dati della fattura',
  error_failed_to_load_created_invoice_list: "Impossibile caricare l'elenco delle fatture create",
  error_failed_to_get_order_for_created_invoice:
    "Impossibile ottenere l'ordine per la fattura creata",
  error_failed_to_load_report_a4: 'Impossibile caricare il report della fattura A4',
  error_failed_to_load_invoice_summary: 'Impossibile caricare il riepilogo della fattura',
  error_failed_to_load_invoice_payment_slip:
    'Impossibile caricare la cedola di pagamento della fattura',
  error_failed_to_load_invoice_a4_detailed: 'Impossibile caricare la fattura A4 dettagliata',
  error_failed_to_load_invoice_journal: 'Impossibile caricare il giornale delle fatture',
  error_failed_to_load_invoice_article_grouping:
    'Impossibile caricare la fattura raggruppata per articoli A4',
  error_failed_to_load_invoice_customer_grouping:
    'Impossibile caricare la fattura raggruppata per clienti A4',
  error_failed_to_load_invoice_delivery_overview:
    'Impossibile caricare il riepilogo delle consegne della fattura',
  error_failed_to_load_invoice_payment_slip_with_qr:
    'Impossibile caricare la cedola di pagamento della fattura con codice QR',
  payment_slip: 'Bollettino di pagamento',
  invoice_summary: 'Riepilogo fattura',
  abacus_export: 'Abacus XML-Export',
  datev_export: 'Esportazione DATEV',
  pdf_export: 'Esportazione PDF',
  invoices_pdf_export: 'Esportazione PDF delle fatture',
  invoice_export: 'Esportazione fatture',
  invoice_summary_export: 'Esportazione riepilogo fatture',
  payment_slip_export: 'Esportazione bollettini di pagamento',
  archive_ready_download_will_start_automatically:
    'Archivio pronto. Il download inizierà automaticamente.',
  archive_is_empty: 'L’archivio è vuoto.',
  following_fields_dont_meet_einvoice_requirements_warning:
    'I seguenti campi non soddisfano i requisiti della fattura elettronica. Si prega di correggerli prima di creare la fattura.',
});

export const invoiceEn = t({
  invoice: 'Invoice',
  invoices_list: 'Invoices list',
  create_invoice: 'Create invoice',
  create_invoices: 'Create invoices',
  number: 'Number',
  customers: 'Customers',
  exported_sepa: 'Exported (SEPA)',
  exported_datev_or_abacus: 'Exported (DATEV/Abacus)',
  invoices: 'Invoices',
  customer_active: 'Customer is active',
  delivery_note_group: 'Delivery note group',
  invoicing_interval: 'Invoicing interval',
  send_letter: 'Send letter',
  email_service: 'Email service',
  no_data_for_export: 'No data for export',
  no_data_for_sepa_export:
    'None of the selected invoices can be exported. Payment may have already been made',
  invoice_date: 'Invoice date',
  text: 'Text',
  creating_invoices: 'Creating invoices – please hold on...',
  processing_multiple_invoices: 'Processing multiple invoices...',
  calculating_totals_preparing_pdfs: 'Calculating totals and preparing PDFs...',
  finalizing_invoice_data: 'Finalizing invoice data...',
  invoices_on_the_way: 'Just a moment – your invoices are on their way!',
  generating_invoice_pdfs: 'Invoices are being prepared as PDFs...',
  creating_billing_documents: 'Billing documents are being created...',
  compiling_multiple_invoices: 'Multiple invoices are being compiled together...',
  finalizing_invoice_layouts: 'The invoice layout is being finalized...',
  preparing_financial_documents_download: 'Financial documents are being prepared for download...',
  bundling_pdfs: 'Almost done – your PDF files are being finalized...',
  sepa_export: 'SEPA Export',
  settings_error: 'Settings error',
  export_valid_only: 'Export valid only',
  some_customers_missed_mandatory_bank_details: 'Some customers missed mandatory bank details',
  the_customers_listed_below_are_missing_mandatory_bank_details:
    'The customers listed below are missing mandatory bank details, so their invoices will be skipped: {{names}}',
  please_complete_the_following_settings_first:
    'Please complete the following settings first: {{list}}',
  complete_the_data: 'Complete the data',
  invoice_journal: 'Invoice journal',
  creating_invoice: 'Creating invoice...',
  orders: 'Orders',
  items: 'Items',
  auto_preview_email: 'Automatic preview/email',
  invoice_no: 'Invoice No.',
  invoice_not_saved: 'Error: Invoice not saved!',
  invoice_with_id_not_saved: 'Error: Invoice {{id}} not saved!',
  invoices_range: 'Invoices range',
  open_invoices_to_date: 'Open invoices to date',
  delete_invoice: 'Delete invoice',
  deleting_invoice: 'Deleting invoice...',
  invoice_successfully_deleted: 'Invoice successfully deleted',
  want_to_delete_invoice: 'Do you really want to delete the invoice?',
  datetime_of_last_email_message: 'Email was sent on {{date}} at {{time}}',
  number_of_created_invoices: 'Number of created invoices',
  legend_is_deleted: 'Deleted invoice',
  email_message:
    'Dear Ladies and Gentlemen\n \nEnclosed you will receive the invoice [FakturaNr] to pay. Thank you for your order.\n \nBest regards',
  action: 'Action',
  delete_reason: 'Delete reason',
  error_order_position_not_loaded: 'Order positions was not uploaded!',
  error_customers_details_not_loaded: 'Customers details was not uploaded!',
  multi_create_invoice: 'Multi create invoices',
  multi_create_invoice_confirmation:
    'Do you want to automatically create invoices for {{count}} customers?',
  multi_create_invoice_confirmation_single_customer:
    'Do you want to automatically create invoices for 1 customer?',
  no_customers_for_multi_create_invoice:
    'There are no eligible customers to multi create invoices.',
  creating_multi_invoice: 'Creating multi invoices',
  error_invoice_not_created: 'Invoice has not been created!',
  manual_selection: 'Manual selection',
  create_multiple_invoices: 'Create multiple invoices',
  error_failed_to_delete_entry: 'Failed to delete entry',
  error_failed_to_load_deleted_invoices: 'Failed to load the deleted invoices',
  error_failed_to_load_order_positions: 'Failed to load the order positions',
  error_failed_to_load_customer_details: 'Failed to load the customer details',
  error_failed_to_load_invoice_data: 'Failed to load the invoice data',
  error_failed_to_load_created_invoice_list: 'Failed to load the created invoice list',
  error_failed_to_get_order_for_created_invoice: 'Failed to get order for the created invoice',
  error_failed_to_load_report_a4: 'Failed to load the invoice report A4',
  error_failed_to_load_invoice_summary: 'Failed to load the invoice summary',
  error_failed_to_load_invoice_payment_slip: 'Failed to load the invoice payment slip',
  error_failed_to_load_invoice_a4_detailed: 'Failed to load the detailed invoice A4',
  error_failed_to_load_invoice_journal: 'Failed to load the invoice journal',
  error_failed_to_load_invoice_article_grouping: 'Failed to load the article grouping invoice A4',
  error_failed_to_load_invoice_customer_grouping: 'Failed to load the customer grouping invoice A4',
  error_failed_to_load_invoice_delivery_overview: 'Failed to load the invoice delivery overview',
  error_failed_to_load_invoice_payment_slip_with_qr:
    'Failed to load the invoice payment slip with QR-code',
  payment_slip: 'Payment slip',
  invoice_summary: 'Invoice summary',
  abacus_export: 'Abacus XML-Export',
  datev_export: 'DATEV export',
  pdf_export: 'PDF Export',
  invoices_pdf_export: 'Invoices PDF export',
  invoice_export: 'Invoice export',
  invoice_summary_export: 'Invoice summary export',
  payment_slip_export: 'Payment slip export',
  archive_ready_download_will_start_automatically:
    'Archive ready. Download will start automatically.',
  archive_is_empty: 'Archive is empty.',
  following_fields_dont_meet_einvoice_requirements_warning:
    'The following fields do not meet e-invoice requirements. Please correct them before creating the invoice.',
});
